// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import itemReducer from './reducers/itemReducer';
import userReduser from './reducers/userReducer';
import ItemMetirialReducer from './reducers/ItemMetirialActionReducers';
import CustormerReducer from './reducers/CustormerReducer';
import firmwareReducer from './reducers/firmwareRedcuer';
import privilegeReducer from './reducers/privilegeReducer';


const store = configureStore({
    reducer: {
        itemsData: itemReducer,
        user: userReduser,
        itemsMetirials: ItemMetirialReducer,
        customers: CustormerReducer,
        users: userReduser,
        userRoles: userReduser,
        privileges: userReduser,
        firmware: firmwareReducer,
        privilege: privilegeReducer,

    },
});

export default store;


